/**
 * AgentFilters Component
 * Filtros y búsqueda para la lista de agentes
 */

import { Box, IconButton, Tooltip, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import GridViewIcon from '@mui/icons-material/GridView';
import ViewAgendaIcon from '@mui/icons-material/ViewAgenda';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import CloudIcon from '@mui/icons-material/Cloud';
import CloudQueueIcon from '@mui/icons-material/CloudQueue';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { useAgentsStore } from '@/store/agentsStore';

export const AgentFilters: React.FC = () => {
  const { filters, setFilters } = useAgentsStore();

  // connectedCount removed (no badge needed)

  const toggleView = () => {
    const next =
      filters.viewMode === 'grid' ? 'list' : filters.viewMode === 'list' ? 'listao' : 'grid';
    setFilters({ viewMode: next as any });
  };

  const getViewIcon = () => {
    // Show the NEXT icon in the cycle
    if (filters.viewMode === 'grid') return <ViewAgendaIcon />;
    if (filters.viewMode === 'list') return <FormatListBulletedIcon />;
    return <GridViewIcon />;
  };

  const getViewTooltip = () => {
    if (filters.viewMode === 'grid') return 'Cambiar a lista';
    if (filters.viewMode === 'list') return 'Cambiar a listao';
    return 'Cambiar a grid';
  };

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 0.5,
        flexWrap: 'wrap',
        alignItems: 'center',
      }}
    >
      {/* Search is provided in the top header; hide local search input to avoid duplication */}

      <FormControl size="small" sx={{ minWidth: 140 }}>
        <InputLabel>Ordenar por</InputLabel>
        <Select
          value={filters.sortBy}
          label="Ordenar por"
          onChange={(e) =>
            setFilters({ sortBy: e.target.value as 'hostname' | 'status' | 'lastSeen' })
          }
        >
          <MenuItem value="hostname">Nombre</MenuItem>
          <MenuItem value="status">Estado</MenuItem>
          <MenuItem value="lastSeen">Última conexión</MenuItem>
        </Select>
      </FormControl>

      <Tooltip title={filters.sortOrder === 'asc' ? 'Ascendente' : 'Descendente'}>
        <IconButton
          size="small"
          aria-label="Cambiar orden ascendente/descendente"
          onClick={() => setFilters({ sortOrder: filters.sortOrder === 'asc' ? 'desc' : 'asc' })}
        >
          {filters.sortOrder === 'asc' ? <ArrowUpwardIcon /> : <ArrowDownwardIcon />}
        </IconButton>
      </Tooltip>

      <Tooltip title={filters.showOffline ? 'Mostrar sólo conectados' : 'Mostrar todos'}>
        <IconButton
          size="small"
          aria-label={filters.showOffline ? 'Mostrar todos los agentes' : 'Mostrar sólo conectados'}
          onClick={() => setFilters({ showOffline: !filters.showOffline })}
          color={filters.showOffline ? 'default' : 'primary'}
        >
          {filters.showOffline ? <CloudQueueIcon /> : <CloudIcon color="success" />}
        </IconButton>
      </Tooltip>

      <Tooltip title={getViewTooltip()}>
        <IconButton size="small" aria-label={getViewTooltip()} onClick={toggleView}>
          {getViewIcon()}
        </IconButton>
      </Tooltip>
    </Box>
  );
};
